import { push } from 'modules/gtm/modules/common';

export const pushOutboundClick = (destinationUrl: string) => {
  push({
    event: 'Generic Event',
    event_name: 'outbound_click',
    outbound_click: {
      event_category: 'outbound click',
      event_action: destinationUrl,
      event_label: undefined,
    },
  });
};
